
const FormGroup = ({children, multi}) => {
    const SPACING = "0.5em";

    const multiStyle = multi && 
    {
        display: "flex",
        gap: SPACING
    };

    const formGroupStyle = {
        marginBottom: SPACING,
        ...multiStyle,
    }
    return (
        <div style={formGroupStyle}>{children}</div>
    );
}

export default FormGroup;